export default __webpack_public_path__ + "static/media/gallery - story - babbitty (1)_02.4260651a.jpg";